import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ManagedStoreService } from '@shared/services/managed-store.service';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { managedStoreAction } from '../actions/managed-store.actions';

@Injectable()
export class ManagedStoreEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private managedStoreService: ManagedStoreService
  ) {}

  managedStoreRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(managedStoreAction.managedStoreRequest),
      tap((_) => this.logger.debug('@Effect [Stores] User managed store request ')),
      switchMap((payload) => {
        return this.managedStoreService
          .userManagedStoreList({ pageNumber: payload.page - 1, pageSize: payload.size, search: payload.search })
          .pipe(
            map((response) => {
              return managedStoreAction.managedStoreResponse({ response });
            }),
            catchError((err) => of(err))
          );
      })
    );
  });
}
